var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z",
    fill: "#1E7C88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33325C6.40924 9.33502 4.88414 9.96772 3.75931 11.0926C2.63447 12.2174 2.00176 13.7425 2 15.3333C2 15.5101 2.07024 15.6796 2.19526 15.8047C2.32029 15.9297 2.48986 15.9999 2.66667 15.9999H13.3333C13.5101 15.9999 13.6797 15.9297 13.8047 15.8047C13.9298 15.6796 14 15.5101 14 15.3333C13.9982 13.7425 13.3655 12.2174 12.2407 11.0926C11.1159 9.96772 9.59076 9.33502 8 9.33325V9.33325Z",
    fill: "#1E7C88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileicon);
export default __webpack_public_path__ + "static/media/profileicon.e96e2cb5b283da336f212bd64c8a6e08.svg";
export { ForwardRef as ReactComponent };